module.exports = __webpack_public_path__ + "images/new_other_insurance_icon.8505d34133a35f01b84dfc68743a6e4b.png";